<template>
  <div class="airST-checkedBaggage" v-bind="$attrs">
    <div>{{ label }}</div>
    <div class="airST-checkedBaggage-speechBubble">
      <h5>{{ title }}</h5>
      <table v-if="rules.length > 0">
        <tbody>
          <tr v-for="(item, idx) in rules" :key="idx">
            <th>{{ item.name }}</th>
            <!-- eslint-disable-next-line -->
            <td v-html="item.content"></td>
          </tr>
        </tbody>
      </table>
      <p>
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TkBaggage',
  props: {
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
}
</script>
